<button mat-icon-button [disabled]="zoningCode.isDeleting" [class.not-clickable-actions-buttons]="zoningCode.isDeleting"
  class="actions-buttons">
  <mat-icon matTooltip="Remove Zoning Code" (click)="deleteZoningCode($event, zoningCode)" class="actions-mat-icons">
    delete</mat-icon>
</button>
